/**
 * Mätning av cookierutan: hur många som ser den och vad de svarar. Går till
 * vår egen /api/consent-log, som skickar vidare till GA4 via Measurement
 * Protocol. Sätter och läser ingenting i webbläsaren och bär ingen
 * identifierare, så även den som avböjer räknas — annars mäter GA4 bara
 * de som redan sagt ja.
 *
 * BANNER_VARIANT är testets nyckel: byt värdet (eller slumpa det per
 * visning) när en ny ruta ska jämföras mot den gamla.
 */
export const BANNER_VARIANT = "2026-09-24-acceptera";

export type ConsentLogEvent =
  | { type: "shown" }
  | {
      type: "choice";
      choice: "accept_all" | "custom";
      via: "button" | "check" | "save";
      analytics: boolean;
      marketing: boolean;
    };

export function logConsent(event: ConsentLogEvent): void {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({ ...event, variant: BANNER_VARIANT, page: window.location.pathname });
  try {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon?.("/api/consent-log", blob)) return;
  } catch {
    // faller tillbaka på fetch
  }
  fetch("/api/consent-log", { method: "POST", body, keepalive: true, headers: { "Content-Type": "application/json" } }).catch(() => {});
}
